import type { Thing, WithContext } from 'schema-dts';

const JSONLD_CHARACTER_MAPPING: Record<string, string> = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&apos;',
};

type Props = {
	schema: WithContext<Thing>;
};

function defaultReplacer(char: string) {
	return JSONLD_CHARACTER_MAPPING[char] ?? char;
}
const defaultReplacePattern = RegExp(`[${Object.keys(JSONLD_CHARACTER_MAPPING).join('')}]`, 'g');

function JSONLDSerializer(_key: string, value: string) {
	if (typeof value === 'string') {
		value = value.replace(defaultReplacePattern, defaultReplacer);
	}

	return value;
}

export function SchemaOrg(props: Props) {
	return (
		<script
			type="application/ld+json"
			// eslint-disable-next-line @eslint-react/dom/no-dangerously-set-innerhtml
			dangerouslySetInnerHTML={{
				__html: JSON.stringify(props.schema, JSONLDSerializer),
			}}
		/>
	);
}
